// Copyright (c) 2016 Deere & Company

import ReimbursementSummarySettings from './components/reimbursement-summary-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    reimbursementSummarySettings: state.user.details.settings.reimbursementSummary
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummarySettings);



// WEBPACK FOOTER //
// ./src/user/reimbursement-summary-settings/state-connector.js